import { useState, useEffect } from "react";
import TriggerModal from "./TriggerModal";
import { MdAdd } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import QuestionForm from "./QuestionForm";
// import TestTrigger from "./TestTrigger";
// import AutoResizableTextarea from "../AutoResizableTextarea";
// import ChatList from "../ChatList";
// import SelectDataSourceModal from "../SelectDataSourceModal";
import { DataState } from "./../../context/DataProvider";
import toast from "react-hot-toast";
import { FaFile } from "react-icons/fa6";
import { submitWorkflowAndGetClarificationQuestions } from "./../../services/workflowApi";
import TriggerModalNew from "./TriggerModalNew"

import {
  integrationData,
  triggerOptionsNew,
} from "../../utils/constants";
import Button from "../custom/Button";
import { FaArrowLeftLong } from "react-icons/fa6";
import SelectedTriggerItem from "./SelectedTriggerItem";
import DataSourceModal from "./DataSourceModal";
import { getFileIcon } from "../chat/AttachmentIcon";

const AiWorkflowForm = ({ /*isModalOpen,*/ closeModal, copyWorkflow = false, copyWorkflowData }) => {

  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  // const [isDataSourceModalOpen, setIsDataSourceModalOpen] = useState(false);

  const [selectTrigerOptions, setSelectTrigerOptions] = useState([]);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const [isDataSourceSelectionModalOpen, setIsDataSourceSelectionModalOpen] =
    useState(false);

  // const [allDataSources, setAllDataSources] = useState([]);
  const [selectedDataSourceFiles, setSelectedDataSourceFiles] = useState([]);
  const [clarificationQuestions, setClarificationQuestions] = useState([]);
  const [workflowId, setWorkflowId] = useState("");

  const {
    // createAndHandleClarificationQuestions,
    setError,
    // setBotCreationId,
    userGoogleId,
    // currentTaskDataSourceFiles,
  } = DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState(""); // State for storing the trigger name
  const [instruction, setInstruction] = useState(""); // State for storing the instruction

  const handleDataSourceModalClose = () => {
    setIsDataSourceSelectionModalOpen(false);
  };

  // useEffect(() => {
  //   if (isModalOpen) {
  //     const createBot = async () => {
  //       try {
  //         const response = await createTempBot({
  //           user_google_id: userGoogleId,
  //         });
  //         if (response.error) {
  //           setError(JSON.stringify(response.error));
  //           console.log("Temp bot creation error:", response.error);
  //           return;
  //         }
  //         if (response.bot_id) {
  //           console.log("Created temp bot:", response.bot_id);
  //           setBotCreationId(response.bot_id);
  //         }
  //       } catch (err) {
  //         setError(JSON.stringify(err));
  //         console.log("Temp bot creation error:", err);
  //       }
  //     };
  //     createBot();
  //   }
  // }, [isModalOpen]);

  const handleDeleteOption = (optionId) => {
    setSelectTrigerOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  // const handleDeleteDataSourceOption = (optionId) => {
  //   setSelectDataSourceOptions((prev) =>
  //     prev.filter((item) => item.id !== optionId)
  //   );
  // };
  const handleTriggerEditOption = (option) => {
    setEditOption(option);
    setIsTriggerModalOpen(true);
  };
  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };

  // const handleDataSourceEditOption = (option) => {
  //   setEditOption(option);
  //   setIsDataSourceModalOpen(true);
  // };

  const [showQuestionForm, setShowQuestionForm] = useState();
  const [showTestScreen, setShowTestScreen] = useState();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const clearStates = () => {
    setSelectTrigerOptions([]);
    setSelectIntegrationOptions([]);
    setSelectDataSourceOptions([]);
    setTriggerName("");
    setInstruction("");
  };


  const createWorkflowAndGetClarificationQuestions = async (
    instruction,
    name,
    trigger,
    apps,
    dataSources
  ) => {
    console.log({
      instruction: instruction,
      name: name,
      trigger: trigger,
      apps: apps,
      dataSources: dataSources,
    });
    try {
      // Create the task bot
      // Extract file IDs to send to the API
      const selectedFileIds = selectedDataSourceFiles.map(
        (file) => file.file_id
      );


      const botResponse = await submitWorkflowAndGetClarificationQuestions(
        userGoogleId,
        instruction,
        name,
        trigger,
        apps,
        selectedFileIds,
      );

      if (botResponse.error) {
        throw new Error(botResponse.error);
      }
      // setClarificationQuestions(botResponse.questions)
      // setCurrentBot(botResponse.bot);
      console.log("Bot Response:", botResponse);
      setWorkflowId(botResponse.workflow_id || "");
      // Check if there are any clarification questions
      if (botResponse.questions && botResponse.questions.length > 0) {
        // Save the clarification questions in the state
        // Transform the list of questions into a list of objects with question and answer keys

        const formattedQuestions = botResponse.questions.map((question) => ({
          id: question.id,
          question: question.question,
          answer: "",
        }));

        // Save the clarification questions in the state

        setClarificationQuestions(formattedQuestions);

        // setClarificationQuestions(botResponse.questions);
      } else {
        console.log("No clarification questions returned");
      }
      
      return botResponse;
    } catch (error) {
      console.error(
        "Error in creating task bot and handling clarification questions:",
        error
      );
      toast.error(
        "Error in creating task bot and handling clarification questions"
      );

      throw error;
    }
  };

  const handleNewInstructionSubmission = async () => {
    setIsFormLoading(true);
    try {
      const final_response = await createWorkflowAndGetClarificationQuestions(
        instruction,
        triggerName,
        selectTrigerOptions,
        selectIntegrationOptions,
        selectDataSourceOptions
      );
      if (final_response && final_response.questions) {
        setShowQuestionForm(true);
      } else {
        console.log("No Questions Returned");
      }
    } catch (error) {
    } finally {
      setIsFormLoading(false);
    }
  };
  const handleShowTestScreen = () => {
    setShowTestScreen(true);
  };

  useEffect(() => {
    if (copyWorkflow) {
      setInstruction(copyWorkflowData.task_description)
      setSelectTrigerOptions(copyWorkflowData.trigger)
      setSelectIntegrationOptions(copyWorkflowData.apps_expanded)
      setSelectDataSourceOptions(copyWorkflowData.dataSources)
    }
  }, [copyWorkflow]);

  
  return (
    <div
      className={`fixed top-0 left-0 bg-black bg-opacity-20 backdrop-blur-sm w-screen h-screen items-center justify-center z-[100] transition-all ease-in-out duration-200 ${true ? "flex" : "hidden"
        }`}
    >
      {copyWorkflowData?.name}
      {!showTestScreen && !showQuestionForm && (
        <div className="bg-1 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 border-b br-1 px-3 py-5 text-p-text">
            <input
              className="px-3 py-1.5 text-p-text rounded-lg outline-none resize-none text-xl font-bold bg-2 w-fit text-center"
              value={triggerName}
              onChange={(e) => setTriggerName(e.target.value)}
              placeholder="Untitled Workflow"
            />
            <div>
              <button
                onClick={closeModal}
                className="bg-1 transition-all duration-200 rounded-lg p-1.5"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Triggers</h1>
                  <p className="text-sm text-p-text">
                    Events that automatically initiates the workflow
                  </p>
                </div>

                <button
                  onClick={() => setIsTriggerModalOpen(true)}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>

              {selectTrigerOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleTriggerEditOption(item)}
                  handleDeleteOption={handleDeleteOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Workflow Instructions
                </h1>
              </div>
              <textarea
                value={instruction}
                onChange={(e) => setInstruction(e.target.value)} // Update instruction state
                className="bg-transparent resize-none h-52 border-zinc-500 r border rounded-lg px-4 py-2 text-base outline-none"
                placeholder="Instructions describe your workflow requirements in detail. Include all necessary steps, data processing instructions, and desired outcomes across integrated applications (e.g. Jira, Email, Sheets, Docs). Example: 'For every email received in the inbox, send an automated apology response explaining a 34 hour delay in support. Then, create a Jira task under the 'Support' Project, including the email content and tagging it as 'High Priority'. Notify the team lead in Slack once task is created."
              />
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Data sources</h1>
                  <p className="text-sm">
                    Add data sources required in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsDataSourceSelectionModalOpen(true)}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>
              {
                <ul className="flex flex-wrap gap-2">
                  {selectedDataSourceFiles.length > 0 &&
                    selectedDataSourceFiles.map((file, idx) => (
                      <li
                        key={idx}
                        className="bg-zinc-100 text-zinc-800 px-3 py-1.5 rounded-full text-sm text-s-text"
                      >
                        <div className="flex items-center gap-2 max-w-[70%]">
                          {/* <FaFile className="text-white" /> */}
                          {getFileIcon(file.original_filename)}
                          <span
                            className="text-sm truncate cursor-pointer hover:whitespace-normal hover:overflow-visible hover:max-w-none transition-all"
                            title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                          >
                            {file.original_filename}
                          </span>
                        </div>
                      </li>
                    ))}
                </ul>
              }
            </div>

            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Continue
              </Button>
            </div>

            <TriggerModalNew
              title="Add trigger"
              desc="Give your assistant access to Oqlous actions."
              isOpen={isTriggerModalOpen}
              onClose={() => {
                setIsTriggerModalOpen(false);
                setEditOption(null);
              }}
              appsData={triggerOptionsNew}
              selectedOptions={selectTrigerOptions}
              setSelectedOptions={setSelectTrigerOptions}
              editOption={editOption}

            />
            <TriggerModal
              title="Add integration"
              desc=" Select the app you’d like to add as integration."
              isOpen={isIntegrationModalOpen}
              onClose={() => {
                setIsIntegrationModalOpen(false);
                setEditOption(null);
              }}
              appsData={integrationData}
              selectedOptions={selectIntegrationOptions}
              setSelectedOptions={setSelectIntegrationOptions}
              editOption={editOption}
            />

            {isDataSourceSelectionModalOpen && (
              <DataSourceModal closeModal={handleDataSourceModalClose} setSelectedDataSourceFiles={setSelectedDataSourceFiles} selectedDataSourceFiles={selectedDataSourceFiles} />
            )}
          </div>
        </div>
      )}
      {showQuestionForm && !showTestScreen && (
        <div className="bg-zinc-900 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 border-b border-zinc-800 px-3 py-5">
            <div className="px-3 py-1.5 bg-transparent text-xl font-bold flex items-center gap-3">
              <button
                onClick={() => setShowQuestionForm(false)}
                className="bg-2 transition-all duration-200 rounded-lg p-1.5"
              >
                <FaArrowLeftLong />
              </button>
              Clarification Questions
            </div>
            <div></div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <QuestionForm
              handleShowTestScreen={handleShowTestScreen}
              clarificationQuestions={clarificationQuestions}
              closeModal={closeModal}
              setShowQuestionForm={setShowQuestionForm}
              clearStates={clearStates}
              workflowId={workflowId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AiWorkflowForm;
